<template lang="pug">
    v-col(cols="12" sm="6" md="4")
        v-card.mx-auto(flat raised)
            v-list-item(three-line)
                v-list-item-content
                    div.overline.mb-4 Texto de ejmplo
                        p.headline.mb-1 Lorem ipsum
                v-list-item-avatar(tile size="80" color="grey")
            v-card-actions
                v-btn(text) View
</template>

<script>
    export default {
        name: "ExampleCard"
    }
</script>

<style>
</style>